import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import BrowseMenuCategoryItems from '../Presentation/BrowseMenuCategoryItems';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { isMobileDevice, getTernaryValue, isCateringDisposition } from 'common/utilities/utils';
import { IMAGE_SIZE_CONSTANTS, ROUTE_URL } from 'common/constants/SharedConstants';

const BrowseMenuContainer = props => {
  const { tenantReducer, dispositionType } = props;
  const menuReducer = useSelector(data => data.menuReducer);
  const [imagesize, setImagesize] = useState({ imageHeight: 0, imageWidth: 0 });
  const { BROWSE_CATEGORIES } = IMAGE_SIZE_CONSTANTS;
  const { BROWSE_MENU_HEADER } = TRANSLATE_MAPPING_KEY;

  const getImageHeight = isMobileSize => {
    const { FIRST_ELE_HEIGHT_DESK, FIRST_ELE_HEIGHT_MOB, REST_ELE_HEIGHT_DESK, REST_ELE_HEIGHT_MOB } =
      BROWSE_CATEGORIES;
    if (isMobileSize) {
      return { firstItem: FIRST_ELE_HEIGHT_MOB, restItem: REST_ELE_HEIGHT_MOB };
    } else {
      return { firstItem: FIRST_ELE_HEIGHT_DESK, restItem: REST_ELE_HEIGHT_DESK };
    }
  };

  const getImageWidth = isMobileSize => {
    const { FIRST_ELE_WIDTH_DESK, FIRST_ELE_WIDTH_MOB, REST_ELE_WIDTH_DESK, REST_ELE_WIDTH_MOB } = BROWSE_CATEGORIES;
    if (isMobileSize) {
      return { firstItem: FIRST_ELE_WIDTH_MOB, restItem: REST_ELE_WIDTH_MOB };
    } else {
      return { firstItem: FIRST_ELE_WIDTH_DESK, restItem: REST_ELE_WIDTH_DESK };
    }
  };

  const windowResized = () => {
    const isMobile = isMobileDevice(window.innerWidth);
    const containerHeight = getImageHeight(isMobile);
    const containerWidth = getImageWidth(isMobile);
    setImagesize({ imageHeight: containerHeight, imageWidth: containerWidth });
  };

  useEffect(() => {
    windowResized();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const browseData = menuReducer?.data?.categories
    ?.filter(category => !category.isHidden)
    ?.map(item => {
      return {
        key: item.id,
        image: item?.imageName,
        name: item?.name,
        dname: item.dname,
        url: item?.url,
        imageContent: { image: item?.content?.image },
        products: item?.products,
      };
    });

  let finalData = [];
  browseData.forEach(item => {
    if (item?.url === TRANSLATE_MAPPING_KEY.LTO_URL) {
      return finalData.unshift(item);
    } else {
      return finalData.push(item);
    }
  });

  const baseUrl = useMemo(() => {
    return getTernaryValue(isCateringDisposition(dispositionType), ROUTE_URL.CATERING_PAGE, ROUTE_URL.MENU_PAGE);
  }, [dispositionType]);

  return imagesize.imageHeight ? (
    <div className='browse-menu-container grid-container'>
      <div className='browse-menu-header browse-menu-header-pos'>
        <span>{translateWithI18Next(BROWSE_MENU_HEADER)}</span>
        <div className='browse-menu-header-border'></div>
      </div>
      <BrowseMenuCategoryItems data={finalData} tenantData={tenantReducer} imagesize={imagesize} baseUrl={baseUrl} />
    </div>
  ) : (
    <></>
  );
};

export default BrowseMenuContainer;
